import { OOMenuItem } from "./oo-menu-item";

export class OOPromoCode {
	pk: string; //venueKey string
	sk: string; //PC_{key}

	//unique identifier of a code. UUIDv4
	key: string;

	//code that will be provided the user to invoke.
	promoCode: string;

	//State of the promo code. If true, promo code is active & accessible. False and the code is disabled for use
	active: boolean = true;
	//Applicable types the code can be used for. Enum TransactionType
	types: number[];

	//displayName provides a friendly (long text) name for the promo code
	displayName: string;

	//value represents the amount that will be deducted from the check when this code is used
	value: number;

	//Menu item that will be rang to hold the negative value promo
	menuItemKey: number;

	//Menu items required on the check for the code to be used
	requiredMenuItemKeys: number[];

	//The minimum amount that the check must be for this promo code to be activated
	minimumAmount: number;

	//effective start date of the promo code
	startDate: string;

	//effective end date of the promo code
	endDate: string;

	//Days of the week starting with Sunday (0) that the code can be used
	availableDays: number[];

	//Menu items that the promo code will apply to. Similar to require items,
	//a promo code discount will be provided for each of the applicable
	//menu items on a check unless 'applyToAllApplicableItems' is false
	applicableMenuItemKeys: number[];

	//If there are applicableMenuItemKeys defined for this promo code
	// this setting dicates if X qty of promo codeo discounts will be provided
	// for each of the applicable menu items on the check;
	applyToAllApplicableItems: boolean;

	//Date promo code was created
	created: string;

	//user key who created the promo code
	createdby: string;

	//quantity of uses
	useCount: number = 0;

	//Value indicating a code has been deleted. Codes will not be permanently deleted from the database, rather they will be flagged as deleted and not visible to users or admins.
	deleted: boolean = false;

	requireMenuItems: OOMenuItem[];
	applicableMenuItems: OOMenuItem[];

	menuItem: OOMenuItem;

	startDateDate: Date;
	endDateDate: Date;

	public constructor(init?: Partial<OOPromoCode>) {
		Object.assign(this, init);
	}
}
